export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;